import statictoy1 from './homeassets/statictoy1.jpg';
import statictoy2 from './homeassets/statictoy2.jpg';
import statictoy3 from './homeassets/statictoy3.jpg';
import statictoy4 from './homeassets/statictoy4.jpg';


const MainCarouselData = [
  {
    id: 1,
    title: "Example Toy 1",
    imageUrl: statictoy1,
    
  },
  {
    id: 2,
    title: "Example Toy 2",
    imageUrl: statictoy2,
    
  },
  {
    id: 3,
    title: "Example Toy 3",
    imageUrl: statictoy3,
    
  },
  {
    id: 4,
    title: "Example Toy 4",
    imageUrl: statictoy4,
    
  },
];

export default MainCarouselData;